import { RgbColorPicker } from 'react-colorful';
import styled from 'styled-components';

const StyledColorPickerContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
	width: 380px;
	padding: 1px;
	border-radius: 10px;
	overflow: hidden;
	isolation: isolate;

	transition: height 0.25s ease;
`;

const StyledColorPicker = styled(RgbColorPicker).attrs({ tabIndex: 0 })`
	display: flex;
	flex-direction: column;
	gap: 20px;
	width: 100% !important;
	height: 250px !important;

	.react-colorful__saturation {
		height: 200px !important;
		border-radius: 10px !important;
		border: none !important;
		box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.25);

		.react-colorful__interactive {
			left: 10px;
			top: 10px;
			width: calc(100% - 20px);
			height: calc(100% - 20px);
		}
	}

	.react-colorful__hue {
		width: 100%;
		height: 30px !important;
		padding: 5px;
		border-radius: 10px !important;
		border: 1px solid rgba(255, 255, 255, 0.1) !important;
		background-color: rgba(255, 255, 255, 0.05) !important;
		background-image: linear-gradient(
			90deg,
			red 0,
			#ff0 17%,
			#0f0 33%,
			#0ff 50%,
			#00f 67%,
			#f0f 83%,
			red
		) !important;
		background-clip: content-box !important;
		background-origin: content-box !important;

		.react-colorful__interactive {
			left: 15px !important;
			right: 15px !important;
			top: 5px !important;
			bottom: 5px !important;
			width: auto !important;
		}
	}

	.react-colorful__pointer {
		width: 10px !important;
		height: 10px !important;
		padding: 5px;
		background-clip: content-box;
		box-shadow: initial !important;
		border: 5px solid rgba(0, 0, 0, 0.25) !important;

		.react-colorful__pointer-fill {
			background-color: white !important;
		}

		outline: none !important;
	}

	.react-colorful__interactive:focus .react-colorful__pointer {
		transform: translate(-50%, -50%) !important;
	}
`;

export { StyledColorPicker, StyledColorPickerContainer };
